/* eslint-disable react/forbid-prop-types */
import PropTypes from 'prop-types';

import { fillerMap } from '../../../../../options';
import ControllersGroup from '../../../controllers/ControllersGroup';
import {
  InputLineController,
  ToggleSwitchController,
  SelectController,
  RangeController,
  ChoiceBoxController,
  CustomSortController,
} from '../../../controllers/Base';

const getOrderKey = (selectedColumn, columns, kpiCategories, inverse) => {
  let key = 'index';
  if (selectedColumn === undefined) {
    key = kpiCategories.length === columns.length - 1 ? 'columns' : 'index';
  } else if (selectedColumn) {
    key = 'columns';
  }
  if (inverse) return key === 'index' ? 'columns' : 'index';
  return key;
};

const GeneralControllers = ({
  handle,
  config,
  data,
  extend,
  setExtend,
  selectedLine = undefined,
  selectedLineMap = undefined,
  selectedColumn = undefined,
  selectedColumnMap = undefined,
  forDrilldown = false,
}) => (
  <>
    <ControllersGroup
      title="Opções Gerais"
      id="general"
      extend={extend}
      setExtend={setExtend}
      sizeIncrease={(
        config?.SortValuesControl === 'Customizado' ? data?.index?.length : 0
      ) + (
        config?.SortColumnsControl === 'Customizado' ? data?.columns?.length : 0
      )}
    >
      {(data?.columns || []).filter((item) => {
        const fItem = typeof item === 'string' ? item : item[item.length - 1];
        return fItem !== 'Totais';
      }).length > 1 && (
        <>
          <SelectController
            label={
              getOrderKey(
                selectedColumn,
                data?.columns ?? [],
                config?.CustomSortControl?.kpiCategories ?? [],
                true,
              ) === 'columns' ? 'Ordenar colunas (subcategorias)' : 'Ordenar linhas (categorias)'
            }
            handle={handle}
            kWord="SortColumnsControl"
            options={[
              { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
              { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
              { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
              { label: 'Customizado', value: 'Customizado', id: 'Customizado' },
            ]}
            configValue={config?.SortColumnsControl ?? 'Não ordenado'}
            fullWidth
          />
          {config?.SortColumnsControl === 'Customizado' && (
            <CustomSortController
              handle={handle}
              kWord="CustomSortColumnControl"
              oldOrder={
                data?.[getOrderKey(
                  selectedColumn,
                  data?.columns ?? [],
                  config?.CustomSortControl?.kpiCategories ?? [],
                  true,
                )] ?? []
              }
              newOrder={config?.CustomSortColumnControl?.kpiCategories || []}
              removeTotal
            />
          )}
        </>
      )}
      <SelectController
        label={
          getOrderKey(
            selectedColumn,
            data?.columns ?? [],
            config?.CustomSortControl?.kpiCategories ?? [],
            false,
          ) === 'index' ? 'Ordenar linhas (categorias)' : 'Ordenar colunas (subcategorias)'
        }
        handle={handle}
        kWord="SortValuesControl"
        options={selectedColumn ? [
          { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
          { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
          { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
          ...(forDrilldown ? [] : [{ label: 'Customizado', value: 'Customizado', id: 'customizado' }]),
        ] : [
          { label: 'Automático', value: 'Não ordenado', id: 'nao-ordenado' },
          { label: 'Alfabética A-Z', value: 'Alfabética A-Z', id: 'alfabetica-a-z' },
          { label: 'Alfabética Z-A', value: 'Alfabética Z-A', id: 'alfabetica-z-a' },
          { label: 'Valor Crescente', value: 'Valor Crescente', id: 'valor-crescente' },
          { label: 'Valor Decrescente', value: 'Valor Decrescente', id: 'valor-decrescente' },
          ...(forDrilldown ? [] : [{ label: 'Customizado', value: 'Customizado', id: 'customizado' }]),
        ]}
        configValue={config?.SortValuesControl}
        fullWidth
      />
      {config?.SortValuesControl === 'Customizado' && (
        <CustomSortController
          handle={handle}
          kWord="CustomSortControlUpt"
          oldOrder={
            data?.[getOrderKey(
              selectedColumn,
              data?.columns ?? [],
              config?.CustomSortControl?.kpiCategories ?? [],
              false,
            )] ?? []
          }
          newOrder={config?.CustomSortControl?.kpiCategories || []}
          removeTotal
        />
      )}
      <RangeController
        label="Margem Superior"
        handle={handle}
        kWord="MarginTop"
        configValue={config?.Margin?.top}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Inferior"
        handle={handle}
        kWord="MarginBottom"
        configValue={config?.Margin?.bottom}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Esquerda"
        handle={handle}
        kWord="MarginLeft"
        configValue={config?.Margin?.left}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <RangeController
        label="Margem Direita"
        handle={handle}
        kWord="MarginRight"
        configValue={config?.Margin?.right}
        min={0}
        max={500}
        step={1}
        precision={0}
        fullWidth
      />
      <ToggleSwitchController
        label="Valor mínimo"
        handle={handle}
        kWord="MinValueControl2"
        configValue={config?.MinValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
      />
      <InputLineController
        isNumber
        precision={2}
        label=""
        handle={handle}
        kWord="MinValue"
        configValue={config?.MinValueControl?.value}
        disabled={config?.MinValueControl?.checked}
      />
      <ToggleSwitchController
        label="Valor máximo"
        handle={handle}
        kWord="MaxValueControl2"
        configValue={config?.MaxValueControl?.checked}
        firstOption="Automático"
        secondOption="Manual"
        secondColor="secondary"
      />
      <InputLineController
        isNumber
        precision={2}
        label=""
        handle={handle}
        kWord="MaxValue"
        configValue={config?.MaxValueControl?.value}
        disabled={config?.MaxValueControl?.checked}
      />
      {data?.columns?.length > 1 && (
        <ToggleSwitchController
          label="Linha de totais"
          handle={handle}
          kWord="TotalLineControl"
          configValue={config?.TotalLineControl}
          firstOption=""
          secondOption=""
          fullWidth
        />
      )}
      {selectedLine?.type === 'datetime64[ns]' && selectedLineMap?.value in fillerMap && (
        <ToggleSwitchController
          label="Preencher datas faltantes na linha"
          handle={handle}
          kWord={`ExtendDateLine-${selectedLineMap?.value ?? 'none'}`}
          configValue={config?.ExtendDateLine}
          firstOption=""
          secondOption=""
          fullWidth
        />
      )}
      {selectedColumn?.type === 'datetime64[ns]' && selectedColumnMap?.value in fillerMap && (
        <ToggleSwitchController
          label="Preencher datas faltantes na coluna"
          handle={handle}
          kWord={`ExtendDateColumn-${selectedColumnMap?.value ?? 'none'}`}
          configValue={config?.ExtendDateColumn}
          firstOption=""
          secondOption=""
          fullWidth
        />
      )}
      <ChoiceBoxController
        label="Dados primários"
        handle={handle}
        kWord="DataFormat"
        configValue={config?.DataFormat}
        options={[
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormat === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormat"
          configValue={config?.DataAbsoluteFormat}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
          ]}
          fullWidth
        />
      )}
      {config?.DataFormat === 'percentual' && data?.columns?.length > 1 && (
        <ChoiceBoxController
          label="Formato percentual"
          handle={handle}
          kWord="DataPercentFormat"
          configValue={config?.DataPercentFormat}
          options={[
            { label: 'Global', value: 'global', id: 'global' },
            { label: 'Categórico', value: 'categoric', id: 'categoric' },
          ]}
          fullWidth
        />
      )}

      <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />

      <ChoiceBoxController
        label="Dados secundários"
        handle={handle}
        kWord="DataFormatAlt"
        configValue={config?.DataFormatAlt}
        options={[
          { value: 'none', label: 'Nenhum', id: 'none' },
          { value: 'absolute', label: 'Absoluto', id: 'absolute' },
          { value: 'percentual', label: 'Percentual', id: 'percentual' },
        ]}
        fullWidth
      />
      {config?.DataFormatAlt === 'absolute' && (
        <ChoiceBoxController
          label="Formato absoluto"
          handle={handle}
          kWord="DataAbsoluteFormatAlt"
          configValue={config?.DataAbsoluteFormatAlt}
          options={[
            { label: 'Número', value: 'number', id: 'number' },
            { label: 'Duração', value: 'duration', id: 'duration' },
            { label: 'Variação', value: 'variation', id: 'variation' },
          ]}
          fullWidth
        />
      )}
      {config?.DataFormatAlt === 'percentual' && (
        <ChoiceBoxController
          label="Formato percentual"
          handle={handle}
          kWord="DataPercentFormatAlt"
          configValue={
            config?.DataPercentFormatAlt === 'categoric' && data?.columns?.length <= 1 ? 'global' : config?.DataPercentFormatAlt
          }
          options={data?.columns?.length > 1 ? [
            { label: 'Global', value: 'global', id: 'global' },
            { label: 'Categórico', value: 'categoric', id: 'categoric' },
            { label: 'Variação', value: 'variation', id: 'variation' },
          ] : [
            { label: 'Global', value: 'global', id: 'global' },
            { label: 'Variação', value: 'variation', id: 'variation' },
          ]}
          fullWidth
        />
      )}
      {(config?.DataPercentFormatAlt === 'variation' || config?.DataAbsoluteFormatAlt === 'variation') && (
        <>
          <span style={{ fontSize: '12px', color: 'gray' }}>
            *A variação é calculada de acordo com a ordenação.
            Caso invertida (seletor abaixo), será calculado do último para o primeiro.
          </span>
          <ToggleSwitchController
            label="Inverter direção da variação"
            handle={handle}
            kWord="InvertVariation"
            configValue={config?.InvertVariation}
            firstOption=""
            secondOption=""
            fullWidth
          />
        </>
      )}
      {(
        (config?.DataFormat === 'absolute' && config?.DataAbsoluteFormat === 'duration')
        || (config?.DataFormatAlt === 'absolute' && config?.DataAbsoluteFormatAlt === 'duration')
      ) && (
        <>
          <hr style={{ width: '100%', color: 'lightgray', opacity: '0.2' }} />
          <ChoiceBoxController
            label="Unidade original"
            handle={handle}
            kWord="DurationUnit"
            configValue={config?.DurationUnit}
            options={[
              { label: 'Dias', value: 'days', id: 'days' },
              { label: 'Horas', value: 'hours', id: 'hours' },
              { label: 'Minutos', value: 'minutes', id: 'minutes' },
              { label: 'Segundos', value: 'seconds', id: 'seconds' },
            ]}
            fullWidth
          />
        </>
      )}
    </ControllersGroup>
  </>
);

GeneralControllers.propTypes = {
  config: PropTypes.objectOf(PropTypes.any),
  data: PropTypes.objectOf(PropTypes.any),
  handle: PropTypes.func,
  extend: PropTypes.string,
  setExtend: PropTypes.func,
  selectedLine: PropTypes.objectOf(PropTypes.any),
  selectedLineMap: PropTypes.objectOf(PropTypes.any),
  selectedColumn: PropTypes.objectOf(PropTypes.any),
  selectedColumnMap: PropTypes.objectOf(PropTypes.any),
  forDrilldown: PropTypes.bool,
};

export default GeneralControllers;
